import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/loyalty', request)
}

async function post(request) {
    return await postMethod('/api/loyalty', request)
}

async function put(loyaltyId, request) {
    return await putMethod(`/api/loyalty/${loyaltyId}`, request)
}

export {post, get, put}
